<template>
  <div class="step-warranty">
    <div class="upsells-component__content">
      <h1 v-html="textQuestion" class="text-center"></h1>

      <div class="title-black mt-4 mb-4">
        {{ textLastChance }}
        <timer-simple-component mins="5" class="d-inline-block" />
        {{ $t("upsells.min") }}...
      </div>

      <div class="px-sm-4">
        <div class="row">
          <div class="col-sm-5 pb-3 text-center">
            <img :src="imageWarranty" alt="" />
          </div>
          <div class="col-sm-7">
            <h2>{{ text2Years }}</h2>
            <ul class="mt-2">
              <li>{{ textFeature1 }}</li>
              <li>{{ textFeature2 }}</li>
            </ul>
          </div>
        </div>

        <div @click="add()" class="warranty-button d-flex align-items-center my-3">
          <img :src="imageShield" />
          <div class="text-center pl-4">
            {{ textAdd }}
          </div>
        </div>

        <p class="no">
          <a @click="$emit('skip')">
            {{ textCancel }}
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { t } from "../../utils/i18n";
import upsells from "../../mixins/upsells";

export default {
  name: "StepWarranty",

  mixins: [upsells],

  props: [],

  data: () => ({
    id: "warranty",
    name: "Warranty",
    productName: "Warranty",
    price: null,
    priceFormatted: null,
    finalPrice: null,
    finalPricePure: null,
    imageUrl: null,
    quantity: 0
  }),

  computed: {
    textLastChance: () => t("upsells.warranty.last-chance"),
    text2Years: () => t("upsells.warranty.2-years"),
    textFeature1: () => t("upsells.warranty.feature-1"),
    textFeature2: () => t("upsells.warranty.feature-2"),
    textCancel: () => t("upsells.warranty.cancel"),
    textQuestion() {
      return this.$t("upsells.warranty.question", {
        PRODUCT: js_data.product.product_name,
        NAME: this.customerName,
        PRICE: this.priceFormatted
      });
    },
    textAdd() {
      return this.$t("upsells.warranty.add-price", { PRICE: this.priceFormatted });
    },

    image5star() {
      return this.$root.cdn_url + "/assets/images/zmc10/5star.svg";
    },
    imageShield() {
      return this.$root.cdn_url + "/assets/images/upsells/shield.svg";
    },
    imageWarranty() {
      return this.$root.cdn_url + "/assets/images/upsells/warranty-2-years.png";
    },

    customerName: () => js_data.order_customer.customer_first_name || localStorage.getItem("stripe_username") || "",
  },

  created() {
    this.quantity = js_data.order_customer.products[0].quantity;
    this.price = js_data.product.prices[this.quantity] ? js_data.product.prices[this.quantity].warranty_price : "0";
    this.priceFormatted = js_data.product.prices[this.quantity] ? js_data.product.prices[this.quantity].warranty_price_text : "0";
    this.finalPricePure = this.price;
    this.finalPrice = this.priceFormatted;

    this.imageUrl = this.$root.cdn_url + "/assets/images/upsells/warranty-picture.png";
  },

  mounted() {},

  methods: {
    add() {
      this.addToCart(this.quantity);
    }
  }
};
</script>

<style lang="scss">
.step-warranty {
  display: flex;
  min-height: 100vh;
  background-color: #333333;

  .upsells-component__content {
      max-width: 747px;
      margin: auto;
      box-shadow: 0px 0px 20px 10px rgba(16, 56, 107, 0.1);
      border-radius: 6px;
      padding: 30px 14px;
      background-color: #fff;
    
  }

  h1 {
    font-size: 24px;
    line-height: 28px;
    font-weight: normal;

    span {
      color: #ff0000;
    }

    p {
      margin-top: 16px;
    }
  }

  h2 {
    font-weight: normal;
    font-size: 24px;
    line-height: 34px;
    color: #333333;
    margin-top: 0;
  }

  li {
    font-size: 20px;
    line-height: 28px;
    color: #333333;
  }

  .title-black {
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    text-align: center;
    color: #106ee8;
  }

  .warranty-button {
    background: linear-gradient(182.34deg, #35a730 1.96%, #3ab334 110.13%);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 3.5px;
    color: #fff;
    padding: 15px 11px;
    font-weight: bold;
    font-size: 21px;
    line-height: 25px;
    cursor: pointer;

    &:hover {
      background: linear-gradient(182.34deg, #35a730 1.96%, rgba(53, 167, 48, 0.6) 110.13%);
    }
  }

  @media screen and (max-width: 767px) {
    background-color: #fff;
    display: block;

    .upsells-component__content {
      box-shadow: none;
    }

    h1 {
      font-size: 21px;
      line-height: 25px;
    }

    .title-black {
      font-size: 16px;
      line-height: 28px;
    }

    h2 {
      font-size: 21px;
      line-height: 25px;
      text-align: center;
    }

    .warranty-button {
      font-size: 18px;
      line-height: 21px;
      margin-left: -15px;
      margin-right: -15px;
      box-shadow: none;
    }

    .no a {
      font-size: 15px;
      line-height: 18px;
    }
  }
}
</style>
